module.exports = __webpack_public_path__ + "img/header_bg1.306c11cf.png";